import { Club } from "@app/core/club/domain/model/club";
import { ClubApiResponse } from "@app/core/shared/domain/api-types-filtered";

export class ClubMapper {
  static deserialize(data: ClubApiResponse): Club {
    return new Club(
      data.id_club,
      data.name_club,
      data.city,
      data.postcode,
      data.club_image,
      data.address,
      data.google_maps_link,
      data.telephone,
      data.website,
      data.all_courts_sacra_active,
    );
  }
}
